import { render, staticRenderFns } from "./InvitationCardEdit.vue?vue&type=template&id=c76677a6&scoped=true&"
import script from "./InvitationCardEdit.vue?vue&type=script&lang=js&"
export * from "./InvitationCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCardEdit.vue?vue&type=style&index=0&id=c76677a6&prod&lang=less&scoped=true&"
import style1 from "./InvitationCardEdit.vue?vue&type=style&index=1&id=c76677a6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76677a6",
  null
  
)

export default component.exports